<template>
  <div class="home-advisor-page">
    <GlobalHeader
      iconType="closeBlack"
      :instructions="instructions"
    />
    <div class="home-advisor-content">
      <div class="home-advisor-logo">
        <img
          id="homeAdvisor_logo_image"
          src="@/assets/images/homeadvisor-logo.png"
        />
      </div>

      <div class="home-advisor-text">
        <p class="home-advisor-title">Hire a qualified,<br />professional installer</p>
        <p class="home-advisor-subtitle">HomeAdvisor connects you with trusted,<br /> local home installation experts that are ready to help.</p>
      </div>

      <div class="home-advisor__button-footer">
        <button
          v-on:click="onLinkTap('tel:8772120015')"
          class="button-primary"
        >
          Call HomeAdvisor
        </button>

        <p class="home-advisor-trademark">HomeAdvisor&reg; and the HomeAdvisor logo are trademarks licensed by IAC.</p>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalHeader from '../components/GlobalHeader';
import { mapState } from 'vuex';
import { get } from 'lodash';

export default {
  name: 'HomeAdvisor',
  components: {
    GlobalHeader,
  },
  computed: {
    ...mapState(['brands']),
    brandTheme() {
      const { brand } = this.$route.params;
      return get(this, ['brands', brand, 'theme'], 'theme not found');
    },
    instructions() {
      const { brand, device, step } = this.$route.params;
      const { returnToApp } = this.$route.query;
      const instructions = get(this, ['brands', brand, 'devices', device, 'installationInstructions', step]);
      if (instructions && returnToApp) {
        instructions.prevStepName = 'https://return-to-app';
      }
      return instructions || {};
    }
  },
  beforeCreate() {
    const { brand } = this.$route.params;
    document.body.classList.add(brand);
  },
  methods: {
    onLinkTap(link) {
      const oWebViewInterface = window.nsWebViewInterface;
      // emit event to native app
      if (oWebViewInterface) {
        oWebViewInterface.emit('linkTapped', link);
      } else {
        window.location.href = link;
      }

      window.ReactNativeWebView && window.ReactNativeWebView.postMessage(
        JSON.stringify({ linkTapped: link })
      );
    },
  },
}
</script>

<style lang="scss">
.home-advisor-page {
  position: relative;
  height: 100%;
}

.home-advisor-content {
  position: absolute;
  top: 50px;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & > div { // Each section fills height
    min-height: 150px;
    flex: 1;
    flex-shrink: 0;
  }
}

.home-advisor-logo {
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: auto;
    height: auto;
    max-width: 250px;
  }
}

.home-advisor-text {
  padding: 0 20px;
}

.home-advisor-title {
  line-height: 30px;
  font-size: 28px;
}

.home-advisor-subtitle {
  margin-top: 15px;
  line-height: 20px;
  font-size: 18px;
}

.home-advisor__button-footer {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0 20px 20px;
  text-align: left;
}

.home-advisor-trademark {
  margin-top: 20px;
  line-height: 14px;
  color: #949494;
  font-size: 12px;
}
</style>
